//© 2025 Kaitlyn Troxell
import { useState, useEffect } from 'react';
import { 
  collection, 
  getDocs, 
  query, 
  where, 
  orderBy 
} from 'firebase/firestore';
import { db } from '../firebase';

function usePunchItems(user, projectId) {
  const [punchItems, setPunchItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPunchItems = async () => {
      if (!user || !projectId) {
        setPunchItems([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const punchQuery = query(
          collection(db, 'punch_items'),
          where('project_id', '==', projectId),
          orderBy('created_at', 'desc')
        );

        const querySnapshot = await getDocs(punchQuery);
        const itemsList = [];

        querySnapshot.forEach((docSnap) => {
          itemsList.push({
            id: docSnap.id,
            ...docSnap.data()
          });
        });

        setPunchItems(itemsList);
      } catch (err) {
        console.error("Error fetching punch items:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPunchItems();
  }, [user, projectId]);

  return { punchItems, setPunchItems, loading };
}

export default usePunchItems;